module.exports = __webpack_public_path__ + "img/level.42b1509d.svg";